import React from "react";

export default function CustomTable({ tableHeader, children }) {
  return (
    <div className="table-blk table-responsive">
      <table className="table border-0 mb-0">
        <thead>
          <tr>
            {tableHeader.map((item) => (
              <th>{item.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
